import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import ColumnLineChart from '../../../shared/columnLineChart';

const GoogleAdWordsCTRChart = () => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { isPaidSearchLoading, CPCBarChart } = dtcData;
    const { categories,data } = CPCBarChart;
    const { isCostApiLoading } = useSelector((state) => state.webMatrix);
    const isLoading = ( isCostApiLoading || isPaidSearchLoading);
    const options = {
        chart: { height: 350, type: 'line' },
        toolbar: { show: false },
        stroke: { width: [0, 4] },
        colors: ['#AD509E', '#E9BEE3'],
        dataLabels: { enabled: false, enabledOnSeries: [1] },
        labels: [
            '01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', 
            '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', 
            '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'
        ],
        yaxis: [
            { title: { text: 'Engagement' } },
            { opposite: true, title: { text: 'CTR' } }
        ],
        legend: {
            show: true,
            horizontalAlign: 'left',
            position: 'top'
        }
    };

    const series = [
        {
            name: 'Google AdWords',
            type: 'column',
            data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
        },
        {
            name: 'CTR',
            type: 'line',
            data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
        }
    ];
    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                Google AdWords CTR
                </Typography>
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <ColumnLineChart height={350} options={options} series={series} type="line" />
                )}
            </Box>
        </Box>
    );
};

export default GoogleAdWordsCTRChart;
